export default "__VITE_ASSET__BnKb5Uc2__"